<div class="desktop-swiper">

  <div class="desktop-owned-swiper-prev swiper-arrow swiper-arrow--left">
    <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'width.px':18 }"></svg-icon>
  </div>

  <swiper [slidesPerView]="slidesPerView" [pagination]="{
          clickable: true
        }" [navigation]="{
          enabled: true,
          nextEl:'.desktop-owned-swiper-next',
          prevEl:'.desktop-owned-swiper-prev',
          disabledClass: 'swiper-arrow--disabled'
        }" [slidesOffsetBefore]="28" [slidesOffsetAfter]="28" [freeMode]="true">
    @for (otherPost of otherPosts; track otherPost.blogId) {
      <ng-template swiperSlide>
        <libero-blog-article-ui-preview [articlePreview]="otherPost"></libero-blog-article-ui-preview>
      </ng-template>
    }
  </swiper>

  <div class="desktop-owned-swiper-next swiper-arrow swiper-arrow--right">
    <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(180deg)' }"></svg-icon>
  </div>

</div>

<div class="mobile-swiper">
  <swiper [slidesPerView]="1.1" [pagination]="{
          clickable: true
        }" [navigation]="{
          enabled: true,
          disabledClass: 'swiper-arrow--disabled'
        }" [slidesOffsetBefore]="28" [slidesOffsetAfter]="28" [freeMode]="true">
    @for (otherPost of otherPosts; track otherPost.blogId) {
      <ng-template swiperSlide>
        <libero-blog-article-ui-preview [articlePreview]="otherPost"></libero-blog-article-ui-preview>
      </ng-template>
    }
  </swiper>
</div>
